import styled from 'styled-components'

import { Box, Flex } from '@/atoms/layout'
import { InputSmallText } from '@/atoms/typography'

export const FileName = styled(InputSmallText)<{ $downloadable: boolean; $hasValidSize: boolean }>`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${({ $downloadable, theme }) => ($downloadable ? theme.colors.violet : theme.colors.paragraph)};
  margin-right: ${({ theme, $hasValidSize }) => ($hasValidSize ? theme.space.S12 : 0)};
`

export const FileNameWrapper = styled(Flex)<{ $downloadable: boolean }>`
  overflow: hidden;
  cursor: ${({ $downloadable }) => ($downloadable ? 'pointer' : 'inherit')};

  &:hover > ${FileName} {
    color: ${({ $downloadable, theme }) => ($downloadable ? theme.colors.violetLight : theme.colors.paragraph)};
  }
`

export const FileIconWrapper = styled(Box)`
  margin-right: ${({ theme }) => theme.space.S8};
`
